import axios from '@/utils/axios'

export function getSiteInspectors() {
    return axios.get('/site-inspectors')
}

export function getSiteInspector(id) {
    return axios.get(`/site-inspectors/${id}`)
}

export function getSiteInspectorDropdown() {
    return axios.get('/site-inspectors/dropdown')
}

export function createSiteInspector(data) {
    return axios.post('/site-inspectors', data)
}

export function updateSiteInspector(id, data) {
    return axios.put(`/site-inspectors/${id}`, data)
}

export function deleteSiteInspector(id) {
    return axios.delete(`/site-inspectors/${id}`)
}